import React from "react";

import {Typography} from "@mui/material";
import {SxProps} from "@mui/material/styles";
import {typografNode} from "../../utils/typograf";
import {H3_FONT_WEIGHT, HEADING_LETTER_SPACING} from "./headingStyles";
import {getPartnerLanguage} from '../../locales/language';

type H3Props = {
    children: React.ReactNode;
    sx?: SxProps;
};

function H3({children, sx}: H3Props) {
    const isEnglish = getPartnerLanguage() === 'en';

    return (
        <Typography component="h3" variant="h3" sx={[{
            fontWeight: isEnglish ? H3_FONT_WEIGHT : 900,
            fontFamily: 'Nexa Heavy, Nexa, Roboto, sans-serif',
            letterSpacing: isEnglish ? HEADING_LETTER_SPACING : 0,
            '@media screen and (min-width: 1400px)': {
                fontSize: '36px',
                lineHeight: 1.3,
            },
            '@media screen and (min-width: 1200px)': {
                fontSize: '36px',
                lineHeight: 1.26,
                position: 'relative',
                top: '4px',
            },
            '@media screen and (min-width: 992px) and (max-width: 1199px)': {
                fontSize: '32px',
                lineHeight: 1.31,
            },
            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                fontSize: '32px',
                lineHeight: 1.26,
                position: 'relative',
                top: '4px',
                overflowWrap: 'normal',
            },
            '@media screen and (min-width: 576px) and (max-width: 767px)': {
                fontSize: '28px',
                lineHeight: 1.26,
                position: 'relative',
                top: '4px',
            },
            '@media screen and (max-width: 575px)': {
                fontSize: '28px',
                lineHeight: 1.26,
                position: 'relative',
                top: '4px',
            },
        }, ...(Array.isArray(sx) ? sx : [sx ?? false])]}>
            {typografNode(children)}
        </Typography>
    );
}

export default H3;
